import Radio from './radio';
import Group from './group';
import Button from './radioButton';

Radio.Button = Button;
Radio.Group = Group;
export { Button, Group };
export default Radio;



// WEBPACK FOOTER //
// ./components/radio/index.tsx